<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Schedule</span>
      <span v-else>Edit Schedule </span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box radio-retouch">
        <v-row>
          <v-col cols="12">
            <v-btn-toggle
              class="width-adjust"
              v-model="toggle_exclusive"
              mandatory
            >
              <v-btn height="auto" class="py-3 radius-12">
                <h4 class="mx-4">
                  <v-img
                    :src="require('@/assets/imgs/junior.png')"
                    width="50px"
                  ></v-img>
                  Team
                </h4>
              </v-btn>
              <v-btn height="auto" class="py-3 radius-12">
                <h4 class="mx-4">
                  <v-img
                    :src="require('@/assets/imgs/team.png')"
                    width="120px"
                  ></v-img
                  >Multiple Team
                </h4>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col cols="12" v-if="toggle_exclusive == 1">
            <v-btn-toggle v-model="toggle_schedules" mandatory>
              <v-btn height="auto" class="py-3 radius-12">
                <h4 class="mx-4">
                  <v-img
                    :src="require('@/assets/imgs/junior.png')"
                    width="40px"
                  ></v-img>
                </h4>
              </v-btn>
              <v-btn height="auto" class="py-3 radius-12">
                <h4 class="mx-4">
                  <v-img
                    :src="require('@/assets/imgs/krypton.png')"
                    width="40px"
                  ></v-img>
                </h4>
              </v-btn>
              <v-btn height="auto" class="py-3 radius-12">
                <h4 class="mx-4">
                  <v-img
                    :src="require('@/assets/imgs/titanium.png')"
                    width="40px"
                  ></v-img>
                </h4>
              </v-btn>
            </v-btn-toggle>
          </v-col>
          <v-col
            v-if="toggle_exclusive == 0"
            cols="12"
            class="align-self-center"
          >
            <h4 class="mb-2">Schedule Photo</h4>
            <section class="file-upload">
              <new-image-upload
                class="file-upload__image"
                :imgUrl="form.photo ? form.photo.path : ''"
                :imgId="form.photo ? form.photo.id : ''"
                @fileSelected="photoChange"
                fieldName="mainPhotoFile"
                :maxSize="maxSize"
                :reset="resetBoolean"
              />
              <template v-if="form.photo != null">
                <a
                  :href="form.photo"
                  target="_blank"
                  v-if="isEdited === true && photoBoolean"
                  class="mt-8"
                >
                  show image
                </a>
              </template>
            </section>
          </v-col>

          <v-col class="py-2" cols="12">
            <form-group name="name" :attribute="`fields.name`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.name"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>

          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import {
  required,
  // decimal,
  // minValue,
  // maxValue,
  maxLength
} from "vuelidate/lib/validators";
export default {
  data() {
    return {
      busLocations: [],
      form: {
        name: ""
      },
      toggle_exclusive: undefined,
      toggle_schedules: undefined,
      maxSize: 2.048,
      resetLogo: false,
      Logo: false,
      Photo: false,
      stopTime: false,
      returnTime: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      countries: [],
      photoBoolean: true,
      hoverPhotoBoolean: true,
      resetBoolean: false,
      photoChangeBoolean: false,
      hoverPhotoChangeBoolean: false
    };
  },
  created() {
    this.editCreateBoolean();
    this.indexBusLocations();
    this.indexCountries();
  },
  methods: {
    indexBusLocations() {
      IndexData({ reqName: "bus-locations" })
        .then(res => {
          const { data } = res.data;
          this.busLocations = data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {});
    },
    indexCountries() {
      IndexData({ reqName: `/countries` })
        .then(res => {
          const { data } = res.data;
          this.countries = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createLocation();
      } else {
        this.editSchedule();
      }
    },
    editCreateBoolean() {
      if (this.$route.name != "CampsSubTypesSchedulesCreate") {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules`,
        id: id
      })
        .then(res => {
          const { schedule } = res.data;
          this.form = schedule;
          if (schedule.classification == null) {
            this.toggle_exclusive = 0;
          } else {
            this.toggle_exclusive = 1;
          }

          if (schedule.classification == "junior") {
            this.toggle_schedules = 0;
          } else if (schedule.classification == "krypton") {
            this.toggle_schedules = 1;
          } else {
            this.toggle_schedules = 2;
          }
        })
        .catch(() => {});
    },
    createLocation() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        if (this.toggle_exclusive == 0) {
          formData.append(formItem, this.form[formItem]);
        } else {
          if (formItem == "photo") {
            return;
          } else {
            if (this.toggle_schedules == 0) {
              formData.append("classification", "junior");
            } else if (this.toggle_schedules == 1) {
              formData.append("classification", "krypton");
            } else {
              formData.append("classification", "titanium");
            }
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      StoreData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules`,
        data: formData
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editSchedule() {
      const formData = new FormData();
      if (!this.photoChangeBoolean || this.toggle_exclusive == 1) {
        delete this.form.photo;
      }

      Object.keys(this.form).forEach(formItem => {
        if (formItem == "sub_type" || formItem == "details") {
          return;
        } else {
          if (this.form[formItem] != null) {
            if (this.toggle_exclusive == 0) {
              if (formItem == "classification") {
                return;
              } else {
                formData.append(formItem, this.form[formItem]);
              }
            } else {
              if (formItem == "photo") {
                return;
              } else {
                if (this.toggle_schedules == 0) {
                  formData.append("classification", "junior");
                } else if (this.toggle_schedules == 1) {
                  formData.append("classification", "krypton");
                } else {
                  formData.append("classification", "titanium");
                }
                formData.append(formItem, this.form[formItem]);
              }
            }
          }
        }
      });
      // if (this.form.photo == null) {
      //   formData.append(this.form.photo, "");
      // }
      formData.append("_method", "put");
      UpdateData({
        reqName: `camp-types/${this.$route.params.id}/sub-types/${this.$route.params.slug}/schedules`,
        data: formData,
        id: this.$route.params.index
      })
        .then(() => {
          this.isEdited = false;
          history.go(-1);

          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    photoChange(photo) {
      this.form.photo = photo.file;
      this.photoBoolean = false;
      this.resetBoolean = false;
      this.photoChangeBoolean = true;
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "CampsSubTypesSchedulesEdit") {
          this.$nextTick(() => {
            this.showData(route.params.index);
          });
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      name: {
        required,
        maxLength: maxLength(190)
      }
    }
  }
};
</script>
